<script>

    import { toast } from 'bulma-toast' 
    import { pickupsStore, modalStore } from '../stores'
    
    import PickupsService from '../$services/pickups.service'
    import DateMethods from '../$methods/date.methods'
    import Delete from '../$components/delete.svelte'

    export let pickup = null

    let loading = false

    async function deletePickup() {

        loading = true
        const resp = await PickupsService.deletePickup(pickup._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pickupsStore.remove(pickup._id)
        toast({message: 'Recolección borrada', type: 'is-success'})
        modalStore.close()
    }


</script>

<div class="columns">
    <div class="column">
        <div class="title">Dirección</div>
        <div>
            <div><b>{ pickup.location.contact }</b></div>
            <div>{ pickup.location.rfc || 'Sin información' }</div>
            <div>{ pickup.location.corporate || 'Sin información' }</div>
            <div>{ pickup.location.phone }</div>
            <div>{ pickup.location.email }</div>
            <div>{ pickup.location.street }</div>
            <div>{ pickup.location.number }, { pickup.location.apartment || '' }</div>
            <div>{ pickup.location.colony }</div>
            <div><b>{ pickup.location.zipcode }</b> { pickup.location.municipality || '' }, { pickup.location.city }, { pickup.location.state }</div>
            <div>{ pickup.location.references }</div>
        </div>
    </div>
    <div class="is-divider-vertical"></div>
    <div class="column">
        <div class="title">Paquete</div>
        <div>
            <div>{ pickup.package.width }cm x { pickup.package.height }cm x { pickup.package.length} cm </div>
            <div>Peso físico { pickup.package.weight }Kg</div>
            <div>Valor declarado ${ pickup.package.value }</div>
            <div>Total de paquetes { pickup.packageTotal }</div>
        </div>
        <div class="is-divider"></div>
        <div class="title">Folio de recolección</div>
        <div class="subtitle">{ pickup.folio }</div>
        <label for="" class="label">Fecha de recolección</label>
        <div>{ DateMethods.dateLarge(pickup.date) }</div>
    </div>
</div>

<div class="buttons">
    <Delete on:confirm={deletePickup} {loading} />
</div>